import { MutationTree } from 'vuex';
import { ContractState } from './state';

const mutations: MutationTree<ContractState> = {
  SET_CONTRACT_ACCEPTED(state, isAccepted: boolean) {
    state.isAccepted = isAccepted;
  },

  SET_CONTRACT_HTML(state, contractHtml: string) {
    state.contractHtml = contractHtml;
  },
};

export default mutations;
